var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupsAdd = function SvgGroupsAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 123.44,
    y1: 244.93,
    x2: 230.93,
    y2: 117.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 54.82,
    y1: 187.23,
    x2: 162.31,
    y2: 59.4,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 62.82,
    y1: 193.96,
    x2: 170.32,
    y2: 66.13,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -4.16,
    y1: 137.63,
    x2: 103.33,
    y2: 9.81,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -1.85,
    y1: 139.57,
    x2: 105.64,
    y2: 11.75,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M194.34,173.21h-9.69v-9.69c0-3.13-2.53-5.66-5.66-5.66s-5.66,2.53-5.66,5.66v9.69h-9.69c-3.13,0-5.66,2.54-5.66,5.66s2.53,5.66,5.66,5.66h9.69v9.68c0,3.13,2.53,5.66,5.66,5.66s5.66-2.53,5.66-5.66v-9.68h9.69c3.13,0,5.66-2.54,5.66-5.66s-2.53-5.66-5.66-5.66Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.56,126.32c8.03-5.02,13.37-13.92,13.39-24.08h0c0-15.68-12.71-28.39-28.39-28.39s-28.39,12.71-28.39,28.39c0,10.16,5.34,19.07,13.37,24.09-15.1,5.98-25.78,20.71-25.78,37.94v14.89c0,1.98,1.6,3.58,3.58,3.58h74.43c1.98,0,3.58-1.6,3.58-3.58v-14.89c0-17.23-10.69-31.97-25.79-37.95ZM70.32,102.24c0-11.73,9.51-21.23,21.24-21.23,11.72.01,21.22,9.51,21.24,21.23,0,11.72-9.5,21.22-21.22,21.23,0,0-.01,0-.02,0s-.01,0-.02,0c-11.72-.01-21.22-9.51-21.22-21.23ZM125.2,175.57H57.92v-11.31c0-18.58,15.06-33.64,33.64-33.64,18.58,0,33.64,15.06,33.64,33.64v11.31Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.31,82.2c-1.71.68-3.38,1.47-5.03,2.4-1.71.97-2.31,3.14-1.35,4.85.97,1.72,3.15,2.34,4.87,1.37,5.04-2.84,10.72-4.33,16.5-4.33,18.58,0,33.65,15.06,33.66,33.64v11.31h-45.22c-1.97,0-3.58,1.6-3.58,3.58s1.6,3.58,3.58,3.58h48.79c1.97,0,3.58-1.6,3.58-3.58v-14.89c0-7.01-1.81-13.91-5.25-20.02-4.78-8.49-12.15-14.6-20.55-17.92,8.04-5.01,13.39-13.93,13.4-24.09h0c0-15.68-12.71-28.39-28.39-28.39-15.68,0-28.39,12.71-28.39,28.39,0,10.16,5.35,19.08,13.38,24.09ZM142.32,36.88c11.72.01,21.22,9.51,21.23,21.23h0c0,11.66-9.39,21.11-21.02,21.23-.13,0-.25,0-.38,0-11.65-.09-21.07-9.56-21.07-21.23,0-11.73,9.51-21.23,21.24-21.23Z",
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.95,135.03c0-1.98-1.6-3.58-3.58-3.58H7.15v-11.31c0-5.78,1.49-11.46,4.33-16.5,6.14-10.91,17.46-17.08,29.15-17.14.05,0,.11,0,.16,0,.04,0,.08,0,.12,0,5.57.01,11.21,1.41,16.4,4.33,1.72.97,3.9.37,4.87-1.35.97-1.72.36-3.9-1.36-4.87-1.63-.92-3.32-1.72-5.05-2.4,8.03-5.01,13.38-13.92,13.4-24.09,0-15.68-12.71-28.39-28.39-28.39s-28.39,12.71-28.39,28.39c0,10.16,5.35,19.08,13.38,24.09C10.68,88.18,0,102.91,0,120.14v14.89c0,1.98,1.6,3.58,3.58,3.58h48.79c1.98,0,3.58-1.6,3.58-3.58ZM19.56,58.11c0-11.73,9.51-21.23,21.24-21.23,11.72.01,21.22,9.51,21.23,21.23,0,11.73-9.51,21.23-21.23,21.23s-21.24-9.51-21.24-21.23Z",
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.56,56.89c15.67-.02,28.37-12.72,28.39-28.39C119.95,12.83,107.24.12,91.56.12s-28.39,12.71-28.39,28.39,12.71,28.39,28.39,28.39ZM91.56,7.27c11.72.01,21.22,9.51,21.24,21.23,0,11.73-9.51,21.23-21.24,21.23s-21.24-9.51-21.24-21.23,9.51-21.23,21.24-21.23Z",
    style: {
      fill: "url(#f)",
      strokeWidth: 0
    }
  }));
};
export default SvgGroupsAdd;